module.exports = __webpack_public_path__ + "img/icon_43.0ba0efec.png";